import { createContext } from "react";

export interface Translation{
   __: (key: string) => string
}

export const TranslationContext = createContext<Translation>({
    __: __
});

export function __(key: string): string{
    return key;
}